import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/clients'
import { qk } from '@/api/queryKeys'
import { useSession } from './session'

/**
 * The signed-in player's own (full) profile: currencies, heat, level for the
 * top bar. Seeded from the sign-in response, then re-read every minute.
 */
export function useSelfProfile() {
  const selfId = useSession((s) => s.player?.playerId ?? null)
  const seed = useSession((s) => s.player)
  return useQuery({
    queryKey: qk.selfProfile(selfId ?? 'none'),
    queryFn: ({ signal }) => api().player.getPlayer({ playerId: selfId! }, { signal }),
    enabled: Boolean(selfId),
    initialData: seed ?? undefined,
    initialDataUpdatedAt: 0,
    refetchInterval: 60_000,
    staleTime: 30_000,
  })
}
